/**
 * Scripts than run globally on every page load.
 */

$(function () {
  // Prevent double submits on forms.
  $('form').submit(function (e) {
    let $form = $(this as Element)

    setTimeout(() => {
      let $buttons = $form.find('button[type=submit]')

      $buttons.each(function () {
        let $btn = $(this as Element)
        $btn.prop('disabled', true)

        // Change button text if data-submitting-text is present
        if ($btn.data('submitting-text')) {
          $btn.text($btn.data('submitting-text'))
        }
      })
    }, 0)
  })
})
